<template>
	<core-layout-content full>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("settings") }}</template>
		</core-layout-headline-and-actions>

		<!-- Body -->
		<div class="flex wrap xs-12">
			<!-- Card -->
			<div
				class="sm-6 md-4 lg-3 xs-12 p2"
				v-for="(card, i) in computedCards"
				:key="i"
			>
				<template>
					<j-card class="xs-12 bg5 p4">
						<h2 class="xs-12 fs6 c6 mb4">{{ card.headline }}</h2>
						<ul class="xs-12 pl6">
							<li v-for="(link, j) in card.links" :key="j" class="mb2 lh125">
								<router-link :to="link.to" class="fw4">
									{{ link.label }}
								</router-link>
							</li>
						</ul>
					</j-card>
				</template>
			</div>
			<div
				class="sm-6 md-4 lg-3 xs-12 p2"
				v-if="$store.state.settings.allowedLocales"
			>
				<j-card class="xs-12 bg5 p4">
					<h2 class="xs-12 fs6 c6 mb4">{{ $t("language") }}</h2>
					<ul class="pl6">
						<li class="mb2 lh125" @click="$modal.show('updateLocaleModal')">
							<div class="cu2 c2">{{ $t("change_language") }}</div>
						</li>
					</ul>
				</j-card>
			</div>
		</div>
		<core-modal name="updateLocaleModal" :headline="$t('change_language')">
			<div class="p4">
				<div class="xs-12 fs3 fw7 pb2">
					{{ $t("language") }}
				</div>
				<core-select-locale
					class="xs-12"
					size="small"
					v-model="selectedLocale"
				/>
				<j-button class="mt4" @click="setLocale"> {{ $t("save") }} </j-button>
			</div>
		</core-modal>
	</core-layout-content>
</template>

<script>
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreModal from "@/modules/core/components/CoreModal"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import CoreSelectLocale from "@/modules/core/components/CoreSelectLocale"

import { i18n } from "@/locales/setup.js"

export default {
	components: {
		JCard,
		JButton,
		CoreLayoutContent,
		CoreModal,
		CoreLayoutHeadlineAndActions,
		CoreSelectLocale
	},
	data() {
		return {
			selectedLocale: i18n.locale
		}
	},

	computed: {
		computedCards() {
			return [
				{
					headline: this.$t("users"),
					links: [
						{
							label: this.$t("manage_users"),
							to: `/${this.$store.state.tenantId}/users/manage-users`
						},
						{
							label: this.$t("organize_user_tree"),
							to: `/${this.$store.state.tenantId}/users/user-groups`
						},
						{
							label: this.$t("more"),
							to: `/${this.$store.state.tenantId}/users/manage-users`
						}
					]
				},
				{
					headline: this.$t("insuranceTypes"),
					links: [
						{
							label: this.$t("manage_types"),
							to: `/${this.$store.state.tenantId}/setup/insurance-types`
						},
						{
							label: this.$t("create_type"),
							to: `/${this.$store.state.tenantId}/setup/insurance-types/create`
						},
						{
							label: this.$t("more"),
							to: `/${this.$store.state.tenantId}/setup/insurance-types`
						}
					]
				},
				{
					headline: this.$t("insurers"),
					links: [
						{
							label: this.$t("manage_insurers"),
							to: `/${this.$store.state.tenantId}/setup/insurers`
						},
						{
							label: this.$t("create_insurer"),
							to: `/${this.$store.state.tenantId}/setup/insurers/create`
						},
						{
							label: this.$t("more"),
							to: `/${this.$store.state.tenantId}/setup/insurers`
						}
					]
				},
				{
					headline: this.$t("templates"),
					links: [
						{
							label: this.$t("manage_templates"),
							to: `/${this.$store.state.tenantId}/templates`
						},
						{
							label: this.$t("create_pdf_template"),
							to: `/${this.$store.state.tenantId}/templates/create/pdf`
						},
						{
							label: this.$t("create_email_template"),
							to: `/${this.$store.state.tenantId}/templates/create/email`
						}
					]
				}
			]
		}
	},

	methods: {
		setLocale() {
			this.$store.dispatch("setLocale", this.selectedLocale)
			this.$modal.hide("updateLocaleModal")
		}
	}
}
</script>
